import React from 'react';
export function BonusSection() {
  const bonuses = [{
    title: 'Actividades Ambientales Listas',
    value: '$9.990',
    desc: 'Más de 50 actividades listas para usar'
  }, {
    title: 'Casos Reales de Argentina',
    value: '$7.990',
    desc: 'Noticias y problemáticas actuales'
  }, {
    title: 'Proyecto de Huerta Escolar',
    value: '$9.990',
    desc: 'Paso a paso completo'
  }, {
    title: 'Planificación Anual Ambiental',
    value: '$7.990',
    desc: 'Todo el año organizado'
  }];
  return <section className="bg-[#071A14] py-4 md:py-5 px-3 border-b border-[#1F3D2B]" data-id="element-16">
      <div className="max-w-3xl mx-auto" data-id="element-17">
        <h2 className="text-xl md:text-2xl font-black text-[#D4A843] text-center mb-3 uppercase tracking-tighter leading-tight" data-id="element-18">
          🎁 BONUS DE REGALO
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 md:gap-3 mb-3" data-id="element-19">
          {bonuses.map((bonus, i) => <div key={i} className="bg-[#102A1F] border border-[#74C69D] glow-green rounded p-3 relative overflow-hidden flex flex-col shadow-sm" data-id="element-20">
              <div className="absolute top-0 right-0 bg-[#D4A843] text-[#000000] text-[9px] font-black px-2 py-0.5 rounded-bl z-10 uppercase" data-id="element-21">
                #{i + 1}
              </div>
              <h3 className="text-xs md:text-sm font-black text-[#FFFFFF] mb-1 flex items-start gap-1.5 mt-0.5 leading-tight uppercase" data-id="element-22">
                <span className="text-[#D4A843]" data-id="element-23">🎁</span>
                <span data-id="element-24">{bonus.title}</span>
              </h3>
              <p className="text-[#BFC9C5] text-[10px] md:text-xs mb-1.5 ml-5 font-bold" data-id="element-25">
                👉 {bonus.desc}
              </p>
              <div className="border-t border-[#1F3D2B] pt-1.5 flex justify-between items-center mt-auto" data-id="element-26">
                <span className="text-[#7A7A7A] line-through text-[9px] md:text-[10px] font-bold" data-id="element-27">
                  Valor: {bonus.value}
                </span>
                <span className="text-[#D4A843] font-black text-xs md:text-sm" data-id="element-28">
                  GRATIS
                </span>
              </div>
            </div>)}
        </div>

        <div className="max-w-xs mx-auto bg-[#102A1F] border-2 border-[#D4A843] rounded p-3 text-center shadow-md" data-id="element-29">
          <p className="text-[#BFC9C5] font-bold text-[10px] md:text-xs mb-1 uppercase tracking-wide leading-none" data-id="element-30">
            Valor total:
          </p>
          <p className="text-base md:text-lg font-black text-[#7A7A7A] line-through mb-1 leading-none" data-id="element-31">
            $35.960
          </p>
          <p className="text-lg md:text-xl font-black text-[#D4A843] glow-gold inline-block leading-none uppercase" data-id="element-32">
            🔥 HOY: GRATIS
          </p>
        </div>
      </div>
    </section>;
}